require('./cardBenefit.scss');
const PropTypes = require('prop-types');
//@vendor
const React = require('react');
//@commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
// @components
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const OKModal = require('components/commons/OKModal/OKModal');

//@utils
const { FormattedText, formatText } = require('core/i18n').i18n;

class CardBenefit extends React.Component {
    constructor(props)
    {
        super(props);
        this.state = {
            showModal: false
        };
        this.handleToggleShowModal= this.handleToggleShowModal.bind(this);
    }
    goToLink(link) {
        return () => window.open(link, '_blank');
    }

        handleToggleShowModal() {
            this.setState(previousState => ({
                showModal: !previousState.showModal
            }));
        }
    render() {
        const { immBenefit,immCard } = this.props;
        const icon = immBenefit.get('icon');
        const text = immBenefit.get('text');
        const title = immBenefit.get('title');
        const innerLinks = immBenefit.get('innerLinks');
        let titleComponent;
        let isR42cardValidType = immCard && (immCard.get('isR42MasterCard') || immCard.get('isMetallic') ||immCard.get('isR42BetaalPasCard'));
        let border = !icon && !!isR42cardValidType ? 'border' : '';
        let size = !icon ? 'col-xs-11': 'row'
        let iconSection;
        let link;
        let link1,link2;
        let benefitLinks;
        let r42MetalicModal;
        if (icon) {
            iconSection = (
                <section className="col-xs-12 card-benefit__image-section pull-left" style={{'paddingLeft':0,"paddingBottom":"10px"}}>
                   {isR42cardValidType ? 
                    <img style={{width:"35px"}} src={icon} />:
                    <span className={`card-benefit__image ${icon}`}> </span>
                   }
                </section>
            );
        }

        if (immBenefit.get('link')) {
            const linkUrl = immBenefit.getIn(['link', 'url']);
            const linkUrlTranslationKey = immBenefit.getIn(['link', 'urlTranslationKey']);
            const linkText = immBenefit.getIn(['link', 'text']);
            const url = !!linkUrlTranslationKey ? formatText(linkUrlTranslationKey) : linkUrl;

            link = (
                <OKButton onClick={this.goToLink(url)} modifier="link-emphasize">
                    <FormattedText value={linkText} />
                </OKButton>
            );
        }

        if(immCard!==undefined && innerLinks){
                    const productSubType = immCard.get('productSubType');
                    const cardBenefitLinksProduct = innerLinks.get(productSubType);
                    const cardBenefitLinksProductAll = innerLinks.get('all');
                    if(cardBenefitLinksProductAll){
                        const benefitLink1 = cardBenefitLinksProductAll.get('link1');
                        benefitLinks = benefitLink1 === 'r42MetalicModalOpen' && (
                            <OKLink
                                modifier="emphasize"
                                target="_self"
                                onClick={this.handleToggleShowModal}
                            >
                                <FormattedText value="cardBenefits-benefitModalLink" />
                            </OKLink>
                        );
                    }
                    else if (cardBenefitLinksProduct) {
                        const benefitLink1 = cardBenefitLinksProduct.get('link1');
                        const benefitLink2 = cardBenefitLinksProduct.get('link2');
                        link1 = benefitLink1 && (
                            <OKLink
                                modifier="emphasize"
                                to={benefitLink1}
                                id={'benefitLink1'}
                                target="_blank"
                            >
                                <FormattedText value="cardBenefits-benefitLink1" />
                            </OKLink>
                        );
                         link2 = benefitLink2 && (
                            <OKLink
                                modifier="emphasize"
                                to={benefitLink2}
                                id={'benefitLink2'}
                                target="_blank"
                            >
                                <FormattedText value="cardBenefits-benefitLink2" />
                            </OKLink>
                        );
                    
                        benefitLinks= link1 && link2 && (
                                    <FormattedTextWithComponents
                                        value="cardBenefits-benefitLinks"
                                        injectedComponents={[link1, link2]}
                                    />
                                );

                    }
}
        if (title) {
            titleComponent = (
                <div className="card-benefit__title">
                    <FormattedText value={title} />
                </div>
            );
        }

if (this.state.showModal){
    let modalContent = (
                <div>
                <section className="card-benefit__text-section">
                <FormattedText value="cardBenefits-benefitModalSubtitleText"/>
                </section>
                <br />
                <div className="card-benefit__title">
                <FormattedText
                    value="cardBenefits-benefitModalContentTitle1"
                /></div>
                 <section className="card-benefit__text-section">
                <FormattedText
                    value="cardBenefits-benefitModalContentText1"
                /></section>
                <br />
                <div className="card-benefit__title">
                <FormattedText
                    value="cardBenefits-benefitModalContentTitle2"
                />
                </div>
                <section className="card-benefit__text-section">
                <FormattedText
                    value="cardBenefits-benefitModalContentText2"
                /></section>
                <br />
                <div className="card-benefit__title">
                <FormattedText
                   value="cardBenefits-benefitModalContentTitle3"
                /></div>
                <section className="card-benefit__text-section">
                <FormattedText
                   value="cardBenefits-benefitModalContentText3"
                /></section>
                <br />
                <div className="card-benefit__title">
                <FormattedText
                   value="cardBenefits-benefitModalContentTitle4"
                /></div>
                <section className="card-benefit__text-section">
                <FormattedText
                   value="cardBenefits-benefitModalContentText4"
                /></section>
                <br />
                <div className="card-benefit__title">
                <FormattedText
                   value="cardBenefits-benefitModalContentTitle5"
                /></div>
                <section className="card-benefit__text-section">
                <FormattedText
                   value="cardBenefits-benefitModalContentText5"
                /></section>
                <br />
                <section className="card-benefit__text-section">
                <FormattedText
                    className="card-benefit__text-section"
                    value="cardBenefits-benefitModalContentText5_2"
                /></section>
               </div>
            
        );
        r42MetalicModal = (
        <OKModal
                    content={modalContent}
                    isOpen={this.state.showModal}
                    onCloseCallback={this.handleToggleShowModal}
                    onPrimaryButtonClick={this.handleToggleShowModal}
                    primaryButtonText={formatText('cardBenefits-benefitModalPrimaryButton')}
                    title={formatText('cardBenefits-benefitModalTitle')}
                    footerType="action"
                />
    )
    }
        return (
            <article className={`card-benefit ${border} ${size}`}>
                {iconSection}
                
                {titleComponent}
                <section className="card-benefit__text-section">
                    <FormattedText value={text} />
                    &nbsp;{benefitLinks}
                    <div className="card-benefit__link">
                        {link}
                    </div>
                </section>
                {r42MetalicModal}
            </article>
        );
    }
}

CardBenefit.propTypes = {
    immBenefit: PropTypes.object,
    immCard: PropTypes.object,
};

module.exports = CardBenefit;
